/**
 * Copies the files of an `<input type="file">` or of a drop, AT ONCE.
 * A FileList is live: resetting the input (`value = ''`) empties it, and the
 * browser empties `dataTransfer.files` when the drop event ends. Handing the
 * list to a React state updater read it too late, during the render: no file
 * reached the server (fixed 2026-10-28).
 */
export function filesOf(list: FileList | null | undefined): File[] {
  return list ? Array.from(list) : [];
}
